declare namespace $ {

	export class $shm_hitalama_vk_token_switch extends $shm_hitalama_components_embed {
		current( ): $shm_hitalama_vk_token | null
	}
	
}

//# sourceMappingURL=switch.view.tree.d.ts.map